<template>
  <div class="crud_form_wrapper">
    <!-- Start:: Title -->
    <div class="form_title_wrapper">
      <h4>{{ $t("TITLES.addCity") }}</h4>
    </div>
    <div class="col-12 text-end">
      <v-btn @click="$router.go(-1)" style="color: #008274">
        <i class="fas fa-backward"></i>
      </v-btn>
    </div>
    <!-- End:: Title -->

    <!-- Start:: Single Step Form Content -->
    <div class="single_step_form_content_wrapper">
      <ValidationObserver v-slot="{ invalid }">
        <form @submit.prevent="validateFormInputs()">
          <div class="row">
            <!-- Start:: Name AR Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.nameAr')"
              rules="required|arabicLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.nameAr')"
                v-model.trim="data.name_ar"
                @input="data.name_ar = allowArabicNumbersSymbols($event)"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Name EN Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.nameEn')"
              rules="required|englishLettersAndNumbersOnly"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-input
                col="12"
                type="text"
                :placeholder="$t('PLACEHOLDERS.nameEn')"
                v-model.trim="data.name_en"
                @input="data.name_en = allowEnglishNumbersSymbols($event)"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: State Input -->
            <ValidationProvider
              :name="$t('PLACEHOLDERS.state')"
              rules="required"
              v-slot="{ errors }"
              class="col-lg-6"
            >
              <base-select-input
                col="12"
                :optionsList="states"
                :placeholder="$t('PLACEHOLDERS.state')"
                v-model="data.state"
                @input="handleStateChange(data.state?.id)"
                :errors="errors[0]"
                required
              />
            </ValidationProvider>

            <!-- Start:: Submit Button Wrapper -->
            <div class="btn_wrapper col-12 text-end">
              <base-button
                class="mt-2"
                styleType="primary_btn"
                :btnText="$t('BUTTONS.save')"
                :isLoading="isWaitingRequest"
                :disabled="invalid || isWaitingRequest"
              />
            </div>
            <!-- End:: Submit Button Wrapper -->
          </div>
        </form>
      </ValidationObserver>
    </div>
    <!-- END:: Single Step Form Content -->
  </div>
</template>

<script>
import moment from "moment";
import allowLanguageMinxin from "@/mixins/allowLanguageMinxins.js";

export default {
  name: "CreateCity",
  mixins: [allowLanguageMinxin],

  data() {
    return {
      // Start:: Loader Control Data
      isWaitingRequest: false,
      // End:: Loader Control Data

      file: null,
      fileType: "",

      // Start:: Data Collection To Send
      data: {
        name_ar: null,
        name_en: null,
        city_id: null,
        active: true,
      },
      // End:: Data Collection To Send
      cities: [],
      states: [],
      areas: [],
      arabicRegex: /^[\u0600-\u06FF\s]+$/,
      EnRegex: /[\u0600-\u06FF]/,
    };
  },

  methods: {
    async getStates() {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `states?page=0&limit=0&status=1&ignorePermissionCheck=1`,
        });
        this.states = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    async getAreas(state_id) {
      try {
        let res = await this.$axios({
          method: "GET",
          url: `areas?page=0&limit=0&status=1&state_id=${state_id}`,
        });
        this.areas = res.data.data;
      } catch (error) {
        console.log(error.response.data.message);
      }
    },
    disabledDate(current) {
      return current && current < moment().startOf("day");
    },

    onCopy(event) {
      event.preventDefault();
    },
    onPaste(event) {
      event.preventDefault();
    },

    validateInput() {
      // Remove non-Arabic characters from the input
      this.data.nameAr = this.data.nameAr.replace(/[^\u0600-\u06FF\s]/g, "");
    },
    removeArabicCharacters() {
      this.data.nameEn = this.data.nameEn.replace(this.EnRegex, "");
    },

    handleFileSelected({ file, fileType }) {
      this.file = file; // Store the selected file in your data
      this.fileType = fileType; // Store the selected file in your data
    },
    handleFileRemoved() {
      this.file = null; // Reset the file when it's removed
      this.fileType = "";
    },

    // Start:: validate Form Inputs
    validateFormInputs() {
      this.isWaitingRequest = true;
      if (!this.data.name_ar) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_ar"));
        return;
      } else if (!this.data.name_en) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.name_en"));
        return;
      } else if (!this.data.state) {
        this.isWaitingRequest = false;
        this.$message.error(this.$t("VALIDATION.area"));
        return;
      } else {
        this.submitForm();
      }
    },
    // End:: validate Form Inputs

    // Start:: Submit Form
    async submitForm() {
      const REQUEST_DATA = new FormData();
      // Start:: Append Request Data
      if (this.data.name_ar) {
        REQUEST_DATA.append("name[ar]", this.data.name_ar);
      }
      if (this.data.name_en) {
        REQUEST_DATA.append("name[en]", this.data.name_en);
      }
      if (this.data.state) {
        REQUEST_DATA.append("state_id", this.data.state?.id);
      }
      if (this.data.area) {
        REQUEST_DATA.append("area_id", this.data.area?.id);
      }
      REQUEST_DATA.append("status", this.data.active ? 1 : 0);

      // Start:: Append Request Data
      try {
        await this.$axios({
          method: "POST",
          url: `cities`,
          data: REQUEST_DATA,
        });
        this.isWaitingRequest = false;
        this.$message.success(this.$t("MESSAGES.addedSuccessfully"));
        this.$router.push({ path: "/cities/all" });
      } catch (error) {
        this.isWaitingRequest = false;
        this.$message.error(error.response.data.message);
      }
    },
    // End:: Submit Form
  },

  created() {
    // Start:: Fire Methods
    this.getStates();
    // End:: Fire Methods
  },
};
</script>
